export enum RetirementTab {
  Overview = 'Overview',
  RetirementIncome = 'Retirement Income',
  MonteCarlo = 'Monte Carlo',
  RothConversion = 'Roth Conversion',
  Assumptions = 'Assumptions',
}
